import { render, staticRenderFns } from "./Headway.vue?vue&type=template&id=3916b582"
import script from "./Headway.vue?vue&type=script&lang=js"
export * from "./Headway.vue?vue&type=script&lang=js"
import style0 from "./Headway.vue?vue&type=style&index=0&id=3916b582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports